// extracted by mini-css-extract-plugin
export default {"button":"MsTeamButton_button__y3h82"};